export const COPYABLE_DETAILS = [
    { key: 'card_status', label: 'Card Status' },
    { key: 'date_opened', label: 'Date Opened' },
    { key: 'account_type', label: 'Account Type' },
    { key: 'credit_limit', label: 'Credit limit' },
    { key: 'annual_fee', label: 'Annual Fee' },
    { key: 'ignore', label: 'Hide this account' },
    { key: 'product_changed', label: 'I product changed to this card' },
    { key: 'bonus_received', label: 'I received a welcome bonus' },
];

export const WELCOME_BONUS_DETAILS = [
    { key: 'minimum_spend_amount', label: 'Minimum spend amount' },
    { key: 'bonus_amount', label: 'Bonus amount' },
    { key: 'minimum_spend_deadline', label: 'Minimum spend deadline' },
];

export const PRODUCT_CHANGED_DETAILS = [
    { key: 'original_card', label: 'Original card' },
    { key: 'product_changed_date_opened', label: 'Date original product was opened' },
    { key: 'product_changed_date', label: 'Date product was changed' },
    { key: 'product_changed_bonus_amount', label: 'Original bonus amount' },
    { key: 'product_changed_min_spend', label: 'Original minimum spend amount' },
];
